import { AppLocale, defaultLocale } from '@shared/i18n';

const LANGUAGES = {
  [AppLocale.KK]: {
    locale: AppLocale.KK,
    text: 'Қазақша',
    shortText: 'Қаз',
  },
  [AppLocale.RU]: {
    locale: AppLocale.RU,
    text: 'Русский',
    shortText: 'Рус',
  },
};

const DEFAULT_LANGUAGE = LANGUAGES[defaultLocale];

export const lngSwitchConfig = {
  LANGUAGES,
  DEFAULT_LANGUAGE,
};
